module.exports = __webpack_public_path__ + "media/images/pc/top/main_01-0f53272371b37d021b62f14e3344f9aa.jpg";